import * as yup from 'yup'

export const licencePlateSchema = (isInternational: boolean) =>
  isInternational
    ? yup.string().trim().matches(/^[A-Z0-9]{1,7}$/, 'Placa não reconhecida').required()
    : yup.string().trim().matches(/[A-Z]{3}[0-9][0-9A-Z][0-9]{2}/, 'Placa não reconhecida').required()

export const schema = yup.object().shape({
  celular: yup
    .string()
    .min(11, 'Digite um número válido')
    .transform((value) => value.replace(/[^\d]/g, ''))
    .required(),
  city: yup.string().required('Selecione uma cidade'),
  area: yup.string(),
  user_name: yup.string(),
  licencePlate: yup
    .string()
    .trim()
    .matches(/[A-Z]{3}[0-9][0-9A-Z][0-9]{2}/, 'Placa não reconhecida')
    .required(),
  vehicle_type: yup.string().trim('Selecione um veículo').required('Selecione um veículo'),
  duration: yup.string().required('Selecione um tempo de duração'),
})
